// import React, { useState } from "react";
// import { AgGridReact } from "ag-grid-react";
// import "ag-grid-enterprise"; // Import Ag-Grid Enterprise features
// import "ag-grid-enterprise/styles/ag-grid.css";
// import 'ag-grid-enterprise/styles/ag-theme-alpine.css';
// import { RowGroupingModule ,ClientSideRowModelModule} from "ag-grid-enterprise";
// import "./IrnValidationModal.css"; // Import your external CSS file

// const IrnValidationModal = ({ isOpen, onClose, irnData }) => {
//   const hasIrn = irnData?.some(item => item.irnNumber);
  
//   console.log("IRN Data:", irnData);
//   const [currentPage, setCurrentPage] = useState(1);
//   if (!isOpen) return null;

//   // const rowsPerPage = 5;

//   // const totalPages = Math.ceil(irnData.length / rowsPerPage);
//   // const paginatedData = irnData.slice(
//   //   (currentPage - 1) * rowsPerPage,
//   //   currentPage * rowsPerPage
//   // );

//   // const handlePrev = () => {
//   //   if (currentPage > 1) setCurrentPage(currentPage - 1);
//   // };

//   // const handleNext = () => {
//   //   if (currentPage < totalPages) setCurrentPage(currentPage + 1);
//   // };

//   const columnInv = [
//     {
//       headerName: "Invoice Number",
//       field: "invoiceNumber",
//       flex: 1,
//     },
//     {
//       headerName: "Financial Year",
//       field: "financialYear",
//       flex: 1,
//       cellRenderer: params => {
//         const message = params.data.message;
//         const style = message === "Invalid Financial Year" ? { color: "red" } : {};
//         return <span style={style}>{params.value}</span>;
//       },
//     },
//     {
//       headerName: "Invoice Type",
//       field: "invoiceType",
//       flex: 1,
//       cellRenderer: params => {
//         const message = params.data.message;
//         const style = message === "Invalid Document Type" ? { color: "red" } : {};
//         return <span style={style}>{params.value}</span>;
//       },
//     },
//     {
//       headerName: "IRP Name",
//       field: "irpName",
//       flex: 1,
//       cellRenderer: params =>
//         params.value || <span className="no-data"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
//       <path d="M10.9987 20.6663C5.93595 20.6663 1.83203 16.5624 1.83203 11.4997C1.83203 6.43692 5.93595 2.33301 10.9987 2.33301C16.0614 2.33301 20.1654 6.43692 20.1654 11.4997C20.1654 16.5624 16.0614 20.6663 10.9987 20.6663ZM10.9987 18.833C12.9436 18.833 14.8089 18.0604 16.1841 16.6851C17.5594 15.3099 18.332 13.4446 18.332 11.4997C18.332 9.55475 17.5594 7.68949 16.1841 6.31422C14.8089 4.93896 12.9436 4.16634 10.9987 4.16634C9.05378 4.16634 7.18851 4.93896 5.81325 6.31422C4.43798 7.68949 3.66536 9.55475 3.66536 11.4997C3.66536 13.4446 4.43798 15.3099 5.81325 16.6851C7.18851 18.0604 9.05378 18.833 10.9987 18.833ZM10.9987 6.91634C11.2418 6.91634 11.475 7.01292 11.6469 7.18483C11.8188 7.35673 11.9154 7.58989 11.9154 7.83301V12.4163C11.9154 12.6595 11.8188 12.8926 11.6469 13.0645C11.475 13.2364 11.2418 13.333 10.9987 13.333C10.7556 13.333 10.5224 13.2364 10.3505 13.0645C10.1786 12.8926 10.082 12.6595 10.082 12.4163V7.83301C10.082 7.58989 10.1786 7.35673 10.3505 7.18483C10.5224 7.01292 10.7556 6.91634 10.9987 6.91634ZM10.9987 16.083C10.7556 16.083 10.5224 15.9864 10.3505 15.8145C10.1786 15.6426 10.082 15.4095 10.082 15.1663C10.082 14.9232 10.1786 14.6901 10.3505 14.5182C10.5224 14.3463 10.7556 14.2497 10.9987 14.2497C11.2418 14.2497 11.475 14.3463 11.6469 14.5182C11.8188 14.6901 11.9154 14.9232 11.9154 15.1663C11.9154 15.4095 11.8188 15.6426 11.6469 15.8145C11.475 15.9864 11.2418 16.083 10.9987 16.083Z" fill="#999999"/>
//     </svg>No Data</span>,
//     },
//     {
//       headerName: "Status",
//       field: "status",
//       flex: 1,
//       cellRenderer: params => {
//         const { status, message } = params.data;
  
//         if (status === "ACT") {
//           return <span className="status registered">Registered</span>;
//         }
  
//         if (message === "IRN is not registered on Invoice Registration Portal (IRP)") {
//           return <span className="status not-registered">Not Registered</span>;
//         }
  
//         return <span className="no-data"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
//         <path d="M10.9987 20.6663C5.93595 20.6663 1.83203 16.5624 1.83203 11.4997C1.83203 6.43692 5.93595 2.33301 10.9987 2.33301C16.0614 2.33301 20.1654 6.43692 20.1654 11.4997C20.1654 16.5624 16.0614 20.6663 10.9987 20.6663ZM10.9987 18.833C12.9436 18.833 14.8089 18.0604 16.1841 16.6851C17.5594 15.3099 18.332 13.4446 18.332 11.4997C18.332 9.55475 17.5594 7.68949 16.1841 6.31422C14.8089 4.93896 12.9436 4.16634 10.9987 4.16634C9.05378 4.16634 7.18851 4.93896 5.81325 6.31422C4.43798 7.68949 3.66536 9.55475 3.66536 11.4997C3.66536 13.4446 4.43798 15.3099 5.81325 16.6851C7.18851 18.0604 9.05378 18.833 10.9987 18.833ZM10.9987 6.91634C11.2418 6.91634 11.475 7.01292 11.6469 7.18483C11.8188 7.35673 11.9154 7.58989 11.9154 7.83301V12.4163C11.9154 12.6595 11.8188 12.8926 11.6469 13.0645C11.475 13.2364 11.2418 13.333 10.9987 13.333C10.7556 13.333 10.5224 13.2364 10.3505 13.0645C10.1786 12.8926 10.082 12.6595 10.082 12.4163V7.83301C10.082 7.58989 10.1786 7.35673 10.3505 7.18483C10.5224 7.01292 10.7556 6.91634 10.9987 6.91634ZM10.9987 16.083C10.7556 16.083 10.5224 15.9864 10.3505 15.8145C10.1786 15.6426 10.082 15.4095 10.082 15.1663C10.082 14.9232 10.1786 14.6901 10.3505 14.5182C10.5224 14.3463 10.7556 14.2497 10.9987 14.2497C11.2418 14.2497 11.475 14.3463 11.6469 14.5182C11.8188 14.6901 11.9154 14.9232 11.9154 15.1663C11.9154 15.4095 11.8188 15.6426 11.6469 15.8145C11.475 15.9864 11.2418 16.083 10.9987 16.083Z" fill="#999999"/>
//       </svg>No Data</span>;
//       },
//     },
//     {
//       headerName: "Date of Registration",
//       field: "regtime",
//       flex: 1.5,
//       cellRenderer: params =>
//         params.value || <span className="no-data"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
//       <path d="M10.9987 20.6663C5.93595 20.6663 1.83203 16.5624 1.83203 11.4997C1.83203 6.43692 5.93595 2.33301 10.9987 2.33301C16.0614 2.33301 20.1654 6.43692 20.1654 11.4997C20.1654 16.5624 16.0614 20.6663 10.9987 20.6663ZM10.9987 18.833C12.9436 18.833 14.8089 18.0604 16.1841 16.6851C17.5594 15.3099 18.332 13.4446 18.332 11.4997C18.332 9.55475 17.5594 7.68949 16.1841 6.31422C14.8089 4.93896 12.9436 4.16634 10.9987 4.16634C9.05378 4.16634 7.18851 4.93896 5.81325 6.31422C4.43798 7.68949 3.66536 9.55475 3.66536 11.4997C3.66536 13.4446 4.43798 15.3099 5.81325 16.6851C7.18851 18.0604 9.05378 18.833 10.9987 18.833ZM10.9987 6.91634C11.2418 6.91634 11.475 7.01292 11.6469 7.18483C11.8188 7.35673 11.9154 7.58989 11.9154 7.83301V12.4163C11.9154 12.6595 11.8188 12.8926 11.6469 13.0645C11.475 13.2364 11.2418 13.333 10.9987 13.333C10.7556 13.333 10.5224 13.2364 10.3505 13.0645C10.1786 12.8926 10.082 12.6595 10.082 12.4163V7.83301C10.082 7.58989 10.1786 7.35673 10.3505 7.18483C10.5224 7.01292 10.7556 6.91634 10.9987 6.91634ZM10.9987 16.083C10.7556 16.083 10.5224 15.9864 10.3505 15.8145C10.1786 15.6426 10.082 15.4095 10.082 15.1663C10.082 14.9232 10.1786 14.6901 10.3505 14.5182C10.5224 14.3463 10.7556 14.2497 10.9987 14.2497C11.2418 14.2497 11.475 14.3463 11.6469 14.5182C11.8188 14.6901 11.9154 14.9232 11.9154 15.1663C11.9154 15.4095 11.8188 15.6426 11.6469 15.8145C11.475 15.9864 11.2418 16.083 10.9987 16.083Z" fill="#999999"/>
//     </svg>No Data</span>,
//     },
//   ];

//   const columnIRN = [
//     {
//       headerName: "IRN Number",
//       field: "irnNumber",
//       flex: 2,
//       enableRowGroup:true,
//       cellRenderer: params => {
//         const message = params.data.message;
//         const style = message === "Invalid IRN" ? { color: "red" } : {};
//         return <span style={style}>{params.value}</span>;
//       },
//     },
//     {
//       headerName: "IRP Name",
//       field: "irpName",
//       flex: 1,
//       cellRenderer: params =>
//         params.value || <span className="no-data"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
//       <path d="M10.9987 20.6663C5.93595 20.6663 1.83203 16.5624 1.83203 11.4997C1.83203 6.43692 5.93595 2.33301 10.9987 2.33301C16.0614 2.33301 20.1654 6.43692 20.1654 11.4997C20.1654 16.5624 16.0614 20.6663 10.9987 20.6663ZM10.9987 18.833C12.9436 18.833 14.8089 18.0604 16.1841 16.6851C17.5594 15.3099 18.332 13.4446 18.332 11.4997C18.332 9.55475 17.5594 7.68949 16.1841 6.31422C14.8089 4.93896 12.9436 4.16634 10.9987 4.16634C9.05378 4.16634 7.18851 4.93896 5.81325 6.31422C4.43798 7.68949 3.66536 9.55475 3.66536 11.4997C3.66536 13.4446 4.43798 15.3099 5.81325 16.6851C7.18851 18.0604 9.05378 18.833 10.9987 18.833ZM10.9987 6.91634C11.2418 6.91634 11.475 7.01292 11.6469 7.18483C11.8188 7.35673 11.9154 7.58989 11.9154 7.83301V12.4163C11.9154 12.6595 11.8188 12.8926 11.6469 13.0645C11.475 13.2364 11.2418 13.333 10.9987 13.333C10.7556 13.333 10.5224 13.2364 10.3505 13.0645C10.1786 12.8926 10.082 12.6595 10.082 12.4163V7.83301C10.082 7.58989 10.1786 7.35673 10.3505 7.18483C10.5224 7.01292 10.7556 6.91634 10.9987 6.91634ZM10.9987 16.083C10.7556 16.083 10.5224 15.9864 10.3505 15.8145C10.1786 15.6426 10.082 15.4095 10.082 15.1663C10.082 14.9232 10.1786 14.6901 10.3505 14.5182C10.5224 14.3463 10.7556 14.2497 10.9987 14.2497C11.2418 14.2497 11.475 14.3463 11.6469 14.5182C11.8188 14.6901 11.9154 14.9232 11.9154 15.1663C11.9154 15.4095 11.8188 15.6426 11.6469 15.8145C11.475 15.9864 11.2418 16.083 10.9987 16.083Z" fill="#999999"/>
//     </svg>No Data</span>,
//     },
//     {
//       headerName: "Status",
//       field: "status",
//       flex: 1,
//       valueGetter: params => {
//         const { status, message } = params.data;
    
//         if (status === "ACT") {
//           return "Registered";
//         }
    
//         if (message === "IRN is not registered on Invoice Registration Portal (IRP)") {
//           return "Not Registered";
//         }
    
//         return "No Data";
//       },
//       cellRenderer: params => {
//         const value = params.value;
    
//         if (value === "Registered") {
//           return <span className="status registered">Registered</span>;
//         }
    
//         if (value === "Not Registered") {
//           return <span className="status not-registered">Not Registered</span>;
//         }
    
//         return <span className="no-data">No Data</span>;
//       },
//     },
    
//     {
//       headerName: "Date of Registration",
//       field: "regtime",
//       flex: 1.5,
//       cellRenderer: params =>
//         params.value || <span className="no-data"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
//       <path d="M10.9987 20.6663C5.93595 20.6663 1.83203 16.5624 1.83203 11.4997C1.83203 6.43692 5.93595 2.33301 10.9987 2.33301C16.0614 2.33301 20.1654 6.43692 20.1654 11.4997C20.1654 16.5624 16.0614 20.6663 10.9987 20.6663ZM10.9987 18.833C12.9436 18.833 14.8089 18.0604 16.1841 16.6851C17.5594 15.3099 18.332 13.4446 18.332 11.4997C18.332 9.55475 17.5594 7.68949 16.1841 6.31422C14.8089 4.93896 12.9436 4.16634 10.9987 4.16634C9.05378 4.16634 7.18851 4.93896 5.81325 6.31422C4.43798 7.68949 3.66536 9.55475 3.66536 11.4997C3.66536 13.4446 4.43798 15.3099 5.81325 16.6851C7.18851 18.0604 9.05378 18.833 10.9987 18.833ZM10.9987 6.91634C11.2418 6.91634 11.475 7.01292 11.6469 7.18483C11.8188 7.35673 11.9154 7.58989 11.9154 7.83301V12.4163C11.9154 12.6595 11.8188 12.8926 11.6469 13.0645C11.475 13.2364 11.2418 13.333 10.9987 13.333C10.7556 13.333 10.5224 13.2364 10.3505 13.0645C10.1786 12.8926 10.082 12.6595 10.082 12.4163V7.83301C10.082 7.58989 10.1786 7.35673 10.3505 7.18483C10.5224 7.01292 10.7556 6.91634 10.9987 6.91634ZM10.9987 16.083C10.7556 16.083 10.5224 15.9864 10.3505 15.8145C10.1786 15.6426 10.082 15.4095 10.082 15.1663C10.082 14.9232 10.1786 14.6901 10.3505 14.5182C10.5224 14.3463 10.7556 14.2497 10.9987 14.2497C11.2418 14.2497 11.475 14.3463 11.6469 14.5182C11.8188 14.6901 11.9154 14.9232 11.9154 15.1663C11.9154 15.4095 11.8188 15.6426 11.6469 15.8145C11.475 15.9864 11.2418 16.083 10.9987 16.083Z" fill="#999999"/>
//     </svg>No Data</span>,
//     },
//   ];

//   const columns = hasIrn ? columnIRN : columnInv;

  

//   const gridOptions = {
//     sideBar: {
//       toolPanels: [
//         {
//           id: "columns",
//           labelDefault: "Columns",
//           labelKey: "columns",
//           iconKey: "columns",
//           toolPanel: "agColumnsToolPanel",
//           minWidth: 225,
//           maxWidth: 225,
//           width: 225,
//         },
//         {
//           id: "filters",
//           labelDefault: "Filters",
//           labelKey: "filters",
//           iconKey: "filter",
//           toolPanel: "agFiltersToolPanel",
//           minWidth: 180,
//           maxWidth: 400,
//           width: 250,
//         },
//         {
//           id: "pdf viewer",
//           labelDefault: "View",
//           labelKey: "view",
//           iconKey: "pdfIcon",
//           toolPanel: "agFiltersToolPanel",
//           minWidth: 180,
//           maxWidth: 400,
//           width: 250,
//         },
//       ],
//       position: "right",
//     },

//     icons: {
//       pdfIcon: `<svg xmlns="https://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
//         <path d="M10.377 11.2188L10.3828 11.1914C10.4961 10.7246 10.6387 10.1426 10.5273 9.61523C10.4531 9.19922 10.1465 9.03711 9.88477 9.02539C9.57617 9.01172 9.30078 9.1875 9.23242 9.44336C9.10352 9.91211 9.21875 10.5527 9.42969 11.3691C9.16406 12.002 8.74023 12.9219 8.42969 13.4688C7.85156 13.7676 7.07617 14.2285 6.96094 14.8105C6.9375 14.918 6.96484 15.0547 7.0293 15.1777C7.10156 15.3145 7.2168 15.4199 7.35156 15.4707C7.41016 15.4922 7.48047 15.5098 7.5625 15.5098C7.90625 15.5098 8.46289 15.2324 9.20508 13.959C9.31836 13.9219 9.43555 13.8828 9.54883 13.8438C10.0801 13.6641 10.6309 13.4766 11.1289 13.3926C11.6797 13.6875 12.3066 13.877 12.7324 13.877C13.1543 13.877 13.3203 13.627 13.3828 13.4766C13.4922 13.2129 13.4395 12.8809 13.2617 12.7031C13.0039 12.4492 12.377 12.3828 11.4004 12.5039C10.9199 12.2109 10.6055 11.8125 10.377 11.2188ZM8.23438 14.1855C7.96289 14.5801 7.75781 14.7773 7.64648 14.8633C7.77734 14.623 8.0332 14.3691 8.23438 14.1855ZM9.94531 9.58594C10.0469 9.75977 10.0332 10.2852 9.95508 10.5508C9.85938 10.1621 9.8457 9.61133 9.90234 9.54688C9.91797 9.54883 9.93164 9.56055 9.94531 9.58594ZM9.91406 11.9395C10.123 12.3008 10.3867 12.6113 10.6777 12.8418C10.2559 12.9375 9.87109 13.0957 9.52734 13.2363C9.44531 13.2695 9.36523 13.3027 9.28711 13.334C9.54688 12.8633 9.76367 12.3301 9.91406 11.9395ZM12.9531 13.2188C12.9551 13.2227 12.957 13.2285 12.9453 13.2363H12.9414L12.9375 13.2422C12.9219 13.252 12.7617 13.3457 12.0723 13.0742C12.8652 13.0371 12.9512 13.2168 12.9531 13.2188ZM16.6914 5.63672L12.4883 1.43359C12.3711 1.31641 12.2129 1.25 12.0469 1.25H3.75C3.4043 1.25 3.125 1.5293 3.125 1.875V18.125C3.125 18.4707 3.4043 18.75 3.75 18.75H16.25C16.5957 18.75 16.875 18.4707 16.875 18.125V6.08008C16.875 5.91406 16.8086 5.75391 16.6914 5.63672ZM15.4336 6.36719H11.7578V2.69141L15.4336 6.36719ZM15.4688 17.3438H4.53125V2.65625H10.4297V6.875C10.4297 7.09256 10.5161 7.30121 10.67 7.45505C10.8238 7.60889 11.0324 7.69531 11.25 7.69531H15.4688V17.3438Z" fill="black" fill-opacity="0.45"/>
//       </svg>`,
//     },
//   };

//   const defaultColDef = {
//     filter: true,
//     sortable: true,
//     enableRowGroup: true,
//     floatingFilter: true,
//   };

//   return (
//     <div className="irn-modal-overlay">
//       <div className="irn-modal">
//         <div className="irn-modal-header">
//             <h3 className="irn-modal-title">Bulk E-Invoice Validation</h3>
//             <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none" onClick={onClose}> 
//             <path d="M7.88477 20.6165L14.0016 14.4996L20.1184 20.6165M20.1184 8.38281L14.0004 14.4996L7.88477 8.38281" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
//             </svg>
//         </div>
//         <div className="irn-modal-body">

//         {/* <p className="irn-modal-warning">*Indicates invalid Data</p> */}

//         <div className="ag-theme-alpine ag-grid-container">
//         <AgGridReact
//             rowData={irnData}
//             columnDefs={columns}
//             rowHeight={50}
//             groupPanel
//             gridOptions={gridOptions}
//             rowGroupPanelShow={"always"}
//             defaultColDef={defaultColDef}
//             modules={[RowGroupingModule]}
//         />
//         </div>
//         {/* Pagination */}
//         {/* {irnData.length > rowsPerPage && (
//             <div className="pagination-container">
//               <button
//                 className="pagination-btn-prev"
//                 onClick={handlePrev}
//                 disabled={currentPage === 1}
//               >
//                 Previous
//               </button>
//               {[...Array(totalPages)].map((_, i) => (
//                 <button
//                   key={i}
//                   className={`pagination-btn ${
//                     currentPage === i + 1 ? "active" : ""
//                   }`}
//                   onClick={() => setCurrentPage(i + 1)}
//                 >
//                   {i + 1}
//                 </button>
//               ))}
//               <button
//                 className="pagination-btn-next"
//                 onClick={handleNext}
//                 disabled={currentPage === totalPages}
//               >
//                 Next
//               </button>
//             </div>
//           )} */}
//         </div>

        
//       </div>
//     </div>
//   );
// };

// export default IrnValidationModal;

import React, { useState ,useRef} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise"; // Import Ag-Grid Enterprise features
import "ag-grid-enterprise/styles/ag-grid.css";
import 'ag-grid-enterprise/styles/ag-theme-alpine.css';
import "./IrnValidationModal.css"; // Import your external CSS file
import { ClientSideRowModelModule , RowGroupingModule} from "ag-grid-enterprise";


const IrnValidationModal = ({ isOpen, onClose, irnData }) => {
  const gridRef = useRef(null);
  const hasIrn = irnData?.some(item => item.irnNumber);
  
  console.log("IRN Data:", irnData);
  const [currentPage, setCurrentPage] = useState(1);
  if (!isOpen) return null;

  // const rowsPerPage = 5;

  // const totalPages = Math.ceil(irnData.length / rowsPerPage);
  // const paginatedData = irnData.slice(
  //   (currentPage - 1) * rowsPerPage,
  //   currentPage * rowsPerPage
  // );

  // const handlePrev = () => {
  //   if (currentPage > 1) setCurrentPage(currentPage - 1);
  // };

  // const handleNext = () => {
  //   if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  // };

 

  const columnInv = [
    {
      headerName: "Gstin",
      field: "gstin",
      flex: 1,
      enableRowGroup:true,
    },
    {
      headerName: "Invoice Number",
      field: "invoiceNumber",
      flex: 1,
      enableRowGroup:true,
    },
    {
      headerName: "Financial Year",
      field: "financialYear",
      flex: 1,
      enableRowGroup:true,
      cellRenderer: params => {
        const message = params.data ? params.data.message : null;
        const style = message === "Invalid Financial Year" ? { color: "red" } : {};
        return <span style={style}>{params.value}</span>;
      },
    },
    {
      headerName: "Invoice Type",
      field: "invoiceType",
      flex: 1,
      enableRowGroup:true,
      cellRenderer: params => {
        const message = params.data ? params.data.message : null;
        const style = message === "Invalid Document Type" ? { color: "red" } : {};
        return <span style={style}>{params.value}</span>;
      },
    },
    {
      headerName: "IRN Number",
      field: "irnInv",
      flex: 2,
      filter: "agTextColumnFilter",
      enableRowGroup:true,
      cellRenderer: params => {
        if (!params.data) return <span>{params.value}</span>;
        
        const message = params.data.message;
        const style = message === "Invalid IRN" ? { color: "red" } : {};
        return <span style={style}>{params.value}</span>;
      }
      
    },
    {
      headerName: "IRP Name",
      field: "irpName",
      flex: 1,
      enableRowGroup:true,
      cellRenderer: params =>
        params.value || <span className="no-data"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
      <path d="M10.9987 20.6663C5.93595 20.6663 1.83203 16.5624 1.83203 11.4997C1.83203 6.43692 5.93595 2.33301 10.9987 2.33301C16.0614 2.33301 20.1654 6.43692 20.1654 11.4997C20.1654 16.5624 16.0614 20.6663 10.9987 20.6663ZM10.9987 18.833C12.9436 18.833 14.8089 18.0604 16.1841 16.6851C17.5594 15.3099 18.332 13.4446 18.332 11.4997C18.332 9.55475 17.5594 7.68949 16.1841 6.31422C14.8089 4.93896 12.9436 4.16634 10.9987 4.16634C9.05378 4.16634 7.18851 4.93896 5.81325 6.31422C4.43798 7.68949 3.66536 9.55475 3.66536 11.4997C3.66536 13.4446 4.43798 15.3099 5.81325 16.6851C7.18851 18.0604 9.05378 18.833 10.9987 18.833ZM10.9987 6.91634C11.2418 6.91634 11.475 7.01292 11.6469 7.18483C11.8188 7.35673 11.9154 7.58989 11.9154 7.83301V12.4163C11.9154 12.6595 11.8188 12.8926 11.6469 13.0645C11.475 13.2364 11.2418 13.333 10.9987 13.333C10.7556 13.333 10.5224 13.2364 10.3505 13.0645C10.1786 12.8926 10.082 12.6595 10.082 12.4163V7.83301C10.082 7.58989 10.1786 7.35673 10.3505 7.18483C10.5224 7.01292 10.7556 6.91634 10.9987 6.91634ZM10.9987 16.083C10.7556 16.083 10.5224 15.9864 10.3505 15.8145C10.1786 15.6426 10.082 15.4095 10.082 15.1663C10.082 14.9232 10.1786 14.6901 10.3505 14.5182C10.5224 14.3463 10.7556 14.2497 10.9987 14.2497C11.2418 14.2497 11.475 14.3463 11.6469 14.5182C11.8188 14.6901 11.9154 14.9232 11.9154 15.1663C11.9154 15.4095 11.8188 15.6426 11.6469 15.8145C11.475 15.9864 11.2418 16.083 10.9987 16.083Z" fill="#999999"/>
    </svg>No Data</span>,
    },
    {
      headerName: "Status",
      field: "status",
      flex: 1,
      enableRowGroup:true,
      cellRenderer: params => {
        const { status, message } = params.data || {};
  
        if (status === "ACT") {
          return <span className="status registered">Registered</span>;
        }
  
        if (message === "IRN is not registered on Invoice Registration Portal (IRP)") {
          return <span className="status not-registered">Not Registered</span>;
        }
  
        return <span className="no-data"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
        <path d="M10.9987 20.6663C5.93595 20.6663 1.83203 16.5624 1.83203 11.4997C1.83203 6.43692 5.93595 2.33301 10.9987 2.33301C16.0614 2.33301 20.1654 6.43692 20.1654 11.4997C20.1654 16.5624 16.0614 20.6663 10.9987 20.6663ZM10.9987 18.833C12.9436 18.833 14.8089 18.0604 16.1841 16.6851C17.5594 15.3099 18.332 13.4446 18.332 11.4997C18.332 9.55475 17.5594 7.68949 16.1841 6.31422C14.8089 4.93896 12.9436 4.16634 10.9987 4.16634C9.05378 4.16634 7.18851 4.93896 5.81325 6.31422C4.43798 7.68949 3.66536 9.55475 3.66536 11.4997C3.66536 13.4446 4.43798 15.3099 5.81325 16.6851C7.18851 18.0604 9.05378 18.833 10.9987 18.833ZM10.9987 6.91634C11.2418 6.91634 11.475 7.01292 11.6469 7.18483C11.8188 7.35673 11.9154 7.58989 11.9154 7.83301V12.4163C11.9154 12.6595 11.8188 12.8926 11.6469 13.0645C11.475 13.2364 11.2418 13.333 10.9987 13.333C10.7556 13.333 10.5224 13.2364 10.3505 13.0645C10.1786 12.8926 10.082 12.6595 10.082 12.4163V7.83301C10.082 7.58989 10.1786 7.35673 10.3505 7.18483C10.5224 7.01292 10.7556 6.91634 10.9987 6.91634ZM10.9987 16.083C10.7556 16.083 10.5224 15.9864 10.3505 15.8145C10.1786 15.6426 10.082 15.4095 10.082 15.1663C10.082 14.9232 10.1786 14.6901 10.3505 14.5182C10.5224 14.3463 10.7556 14.2497 10.9987 14.2497C11.2418 14.2497 11.475 14.3463 11.6469 14.5182C11.8188 14.6901 11.9154 14.9232 11.9154 15.1663C11.9154 15.4095 11.8188 15.6426 11.6469 15.8145C11.475 15.9864 11.2418 16.083 10.9987 16.083Z" fill="#999999"/>
      </svg>No Data</span>;
      },
    },
    {
      headerName: "Date of Registration",
      field: "regtime",
      flex: 1.5,
      enableRowGroup:true,
      cellRenderer: params =>
        params.value || <span className="no-data"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
      <path d="M10.9987 20.6663C5.93595 20.6663 1.83203 16.5624 1.83203 11.4997C1.83203 6.43692 5.93595 2.33301 10.9987 2.33301C16.0614 2.33301 20.1654 6.43692 20.1654 11.4997C20.1654 16.5624 16.0614 20.6663 10.9987 20.6663ZM10.9987 18.833C12.9436 18.833 14.8089 18.0604 16.1841 16.6851C17.5594 15.3099 18.332 13.4446 18.332 11.4997C18.332 9.55475 17.5594 7.68949 16.1841 6.31422C14.8089 4.93896 12.9436 4.16634 10.9987 4.16634C9.05378 4.16634 7.18851 4.93896 5.81325 6.31422C4.43798 7.68949 3.66536 9.55475 3.66536 11.4997C3.66536 13.4446 4.43798 15.3099 5.81325 16.6851C7.18851 18.0604 9.05378 18.833 10.9987 18.833ZM10.9987 6.91634C11.2418 6.91634 11.475 7.01292 11.6469 7.18483C11.8188 7.35673 11.9154 7.58989 11.9154 7.83301V12.4163C11.9154 12.6595 11.8188 12.8926 11.6469 13.0645C11.475 13.2364 11.2418 13.333 10.9987 13.333C10.7556 13.333 10.5224 13.2364 10.3505 13.0645C10.1786 12.8926 10.082 12.6595 10.082 12.4163V7.83301C10.082 7.58989 10.1786 7.35673 10.3505 7.18483C10.5224 7.01292 10.7556 6.91634 10.9987 6.91634ZM10.9987 16.083C10.7556 16.083 10.5224 15.9864 10.3505 15.8145C10.1786 15.6426 10.082 15.4095 10.082 15.1663C10.082 14.9232 10.1786 14.6901 10.3505 14.5182C10.5224 14.3463 10.7556 14.2497 10.9987 14.2497C11.2418 14.2497 11.475 14.3463 11.6469 14.5182C11.8188 14.6901 11.9154 14.9232 11.9154 15.1663C11.9154 15.4095 11.8188 15.6426 11.6469 15.8145C11.475 15.9864 11.2418 16.083 10.9987 16.083Z" fill="#999999"/>
    </svg>No Data</span>,
    },
  ];

  const columnIRN = [
    {
      headerName: "IRN Number",
      field: "irnNumber",
      flex: 2,
      filter: "agTextColumnFilter",
      enableRowGroup:true,
      cellRenderer: params => {
        if (!params.data) return <span>{params.value}</span>;
        
        const message = params.data.message;
        const style = message === "Invalid IRN" ? { color: "red" } : {};
        return <span style={style}>{params.value}</span>;
      }
      
    },
    {
      headerName: "IRP Name",
      field: "irpName",
      enableRowGroup:true,
      filter: "agTextColumnFilter",
      flex: 1,
      cellRenderer: params =>
        params.value || <span className="no-data"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
      <path d="M10.9987 20.6663C5.93595 20.6663 1.83203 16.5624 1.83203 11.4997C1.83203 6.43692 5.93595 2.33301 10.9987 2.33301C16.0614 2.33301 20.1654 6.43692 20.1654 11.4997C20.1654 16.5624 16.0614 20.6663 10.9987 20.6663ZM10.9987 18.833C12.9436 18.833 14.8089 18.0604 16.1841 16.6851C17.5594 15.3099 18.332 13.4446 18.332 11.4997C18.332 9.55475 17.5594 7.68949 16.1841 6.31422C14.8089 4.93896 12.9436 4.16634 10.9987 4.16634C9.05378 4.16634 7.18851 4.93896 5.81325 6.31422C4.43798 7.68949 3.66536 9.55475 3.66536 11.4997C3.66536 13.4446 4.43798 15.3099 5.81325 16.6851C7.18851 18.0604 9.05378 18.833 10.9987 18.833ZM10.9987 6.91634C11.2418 6.91634 11.475 7.01292 11.6469 7.18483C11.8188 7.35673 11.9154 7.58989 11.9154 7.83301V12.4163C11.9154 12.6595 11.8188 12.8926 11.6469 13.0645C11.475 13.2364 11.2418 13.333 10.9987 13.333C10.7556 13.333 10.5224 13.2364 10.3505 13.0645C10.1786 12.8926 10.082 12.6595 10.082 12.4163V7.83301C10.082 7.58989 10.1786 7.35673 10.3505 7.18483C10.5224 7.01292 10.7556 6.91634 10.9987 6.91634ZM10.9987 16.083C10.7556 16.083 10.5224 15.9864 10.3505 15.8145C10.1786 15.6426 10.082 15.4095 10.082 15.1663C10.082 14.9232 10.1786 14.6901 10.3505 14.5182C10.5224 14.3463 10.7556 14.2497 10.9987 14.2497C11.2418 14.2497 11.475 14.3463 11.6469 14.5182C11.8188 14.6901 11.9154 14.9232 11.9154 15.1663C11.9154 15.4095 11.8188 15.6426 11.6469 15.8145C11.475 15.9864 11.2418 16.083 10.9987 16.083Z" fill="#999999"/>
    </svg>No Data</span>,
    },
    {
      headerName: "Status",
      field: "status",
      enableRowGroup:true,
      flex: 1,
       filterParams: {
    defaultOption: 'startsWith',
  },
      valueGetter: params => {
        const data = params.data;
      
        if (!data) return "No Data"; // or return null if you prefer
      
        const { status, message } = data;
      
        if (status === "ACT") {
          return "Registered";
        }
      
        if (message === "IRN is not registered on Invoice Registration Portal (IRP)") {
          return "Not Registered";
        }
      
        return "No Data";
      },
      cellRenderer: params => {
        const value = params.value;
    
        if (value === "Registered") {
          return <span className="status registered">Registered</span>;
        }
    
        if (value === "Not Registered") {
          return <span className="status not-registered">Not Registered</span>;
        }
    
        return <span className="no-data">No Data</span>;
      },
    },
    
    {
      headerName: "Date of Registration",
      field: "regtime",
      enableRowGroup:true,
      flex: 1.5,
      cellRenderer: params =>
        params.value || <span className="no-data"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
      <path d="M10.9987 20.6663C5.93595 20.6663 1.83203 16.5624 1.83203 11.4997C1.83203 6.43692 5.93595 2.33301 10.9987 2.33301C16.0614 2.33301 20.1654 6.43692 20.1654 11.4997C20.1654 16.5624 16.0614 20.6663 10.9987 20.6663ZM10.9987 18.833C12.9436 18.833 14.8089 18.0604 16.1841 16.6851C17.5594 15.3099 18.332 13.4446 18.332 11.4997C18.332 9.55475 17.5594 7.68949 16.1841 6.31422C14.8089 4.93896 12.9436 4.16634 10.9987 4.16634C9.05378 4.16634 7.18851 4.93896 5.81325 6.31422C4.43798 7.68949 3.66536 9.55475 3.66536 11.4997C3.66536 13.4446 4.43798 15.3099 5.81325 16.6851C7.18851 18.0604 9.05378 18.833 10.9987 18.833ZM10.9987 6.91634C11.2418 6.91634 11.475 7.01292 11.6469 7.18483C11.8188 7.35673 11.9154 7.58989 11.9154 7.83301V12.4163C11.9154 12.6595 11.8188 12.8926 11.6469 13.0645C11.475 13.2364 11.2418 13.333 10.9987 13.333C10.7556 13.333 10.5224 13.2364 10.3505 13.0645C10.1786 12.8926 10.082 12.6595 10.082 12.4163V7.83301C10.082 7.58989 10.1786 7.35673 10.3505 7.18483C10.5224 7.01292 10.7556 6.91634 10.9987 6.91634ZM10.9987 16.083C10.7556 16.083 10.5224 15.9864 10.3505 15.8145C10.1786 15.6426 10.082 15.4095 10.082 15.1663C10.082 14.9232 10.1786 14.6901 10.3505 14.5182C10.5224 14.3463 10.7556 14.2497 10.9987 14.2497C11.2418 14.2497 11.475 14.3463 11.6469 14.5182C11.8188 14.6901 11.9154 14.9232 11.9154 15.1663C11.9154 15.4095 11.8188 15.6426 11.6469 15.8145C11.475 15.9864 11.2418 16.083 10.9987 16.083Z" fill="#999999"/>
    </svg>No Data</span>,
    },
  ];

  const columns = hasIrn ? columnIRN : columnInv;

  

  const gridOptions = {
    sideBar: {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          minWidth: 225,
          maxWidth: 225,
          width: 225,
        },
        {
          id: "filters",
          labelDefault: "Filters",
          labelKey: "filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel",
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
        {
          id: "pdf viewer",
          labelDefault: "View",
          labelKey: "view",
          iconKey: "pdfIcon",
          toolPanel: "agFiltersToolPanel",
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
      ],
      position: "right",
    },

    icons: {
      pdfIcon: `<svg xmlns="https://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10.377 11.2188L10.3828 11.1914C10.4961 10.7246 10.6387 10.1426 10.5273 9.61523C10.4531 9.19922 10.1465 9.03711 9.88477 9.02539C9.57617 9.01172 9.30078 9.1875 9.23242 9.44336C9.10352 9.91211 9.21875 10.5527 9.42969 11.3691C9.16406 12.002 8.74023 12.9219 8.42969 13.4688C7.85156 13.7676 7.07617 14.2285 6.96094 14.8105C6.9375 14.918 6.96484 15.0547 7.0293 15.1777C7.10156 15.3145 7.2168 15.4199 7.35156 15.4707C7.41016 15.4922 7.48047 15.5098 7.5625 15.5098C7.90625 15.5098 8.46289 15.2324 9.20508 13.959C9.31836 13.9219 9.43555 13.8828 9.54883 13.8438C10.0801 13.6641 10.6309 13.4766 11.1289 13.3926C11.6797 13.6875 12.3066 13.877 12.7324 13.877C13.1543 13.877 13.3203 13.627 13.3828 13.4766C13.4922 13.2129 13.4395 12.8809 13.2617 12.7031C13.0039 12.4492 12.377 12.3828 11.4004 12.5039C10.9199 12.2109 10.6055 11.8125 10.377 11.2188ZM8.23438 14.1855C7.96289 14.5801 7.75781 14.7773 7.64648 14.8633C7.77734 14.623 8.0332 14.3691 8.23438 14.1855ZM9.94531 9.58594C10.0469 9.75977 10.0332 10.2852 9.95508 10.5508C9.85938 10.1621 9.8457 9.61133 9.90234 9.54688C9.91797 9.54883 9.93164 9.56055 9.94531 9.58594ZM9.91406 11.9395C10.123 12.3008 10.3867 12.6113 10.6777 12.8418C10.2559 12.9375 9.87109 13.0957 9.52734 13.2363C9.44531 13.2695 9.36523 13.3027 9.28711 13.334C9.54688 12.8633 9.76367 12.3301 9.91406 11.9395ZM12.9531 13.2188C12.9551 13.2227 12.957 13.2285 12.9453 13.2363H12.9414L12.9375 13.2422C12.9219 13.252 12.7617 13.3457 12.0723 13.0742C12.8652 13.0371 12.9512 13.2168 12.9531 13.2188ZM16.6914 5.63672L12.4883 1.43359C12.3711 1.31641 12.2129 1.25 12.0469 1.25H3.75C3.4043 1.25 3.125 1.5293 3.125 1.875V18.125C3.125 18.4707 3.4043 18.75 3.75 18.75H16.25C16.5957 18.75 16.875 18.4707 16.875 18.125V6.08008C16.875 5.91406 16.8086 5.75391 16.6914 5.63672ZM15.4336 6.36719H11.7578V2.69141L15.4336 6.36719ZM15.4688 17.3438H4.53125V2.65625H10.4297V6.875C10.4297 7.09256 10.5161 7.30121 10.67 7.45505C10.8238 7.60889 11.0324 7.69531 11.25 7.69531H15.4688V17.3438Z" fill="black" fill-opacity="0.45"/>
      </svg>`,
    },
  };

  const defaultColDef = {
    filter: true,
    sortable: true,
    enableRowGroup: true,
    floatingFilter: true,
    filter: "agTextColumnFilter",
  };
 

  return (
    <div className="irn-modal-overlay">
      <div className="irn-modal">
        <div className="irn-modal-header">
            <h3 className="irn-modal-title">Bulk E-Invoice Validation</h3>
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none" onClick={onClose}> 
            <path d="M7.88477 20.6165L14.0016 14.4996L20.1184 20.6165M20.1184 8.38281L14.0004 14.4996L7.88477 8.38281" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div className="irn-modal-body">

        {/* <p className="irn-modal-warning">*Indicates invalid Data</p> */}

        <div className="ag-theme-alpine ag-grid-container">
        <AgGridReact
            rowData={irnData}
            columnDefs={columns}
            rowHeight={50}
            ref={gridRef}
            groupPanel
            gridOptions={gridOptions}
            rowGroupPanelShow={"always"}
            defaultColDef={defaultColDef}
            modules={[ClientSideRowModelModule,RowGroupingModule]}
            //suppressCellSelection={true}
            //enableRangeSelection={true}
        />
        </div>
        {/* Pagination */}
        {/* {irnData.length > rowsPerPage && (
            <div className="pagination-container">
              <button
                className="pagination-btn-prev"
                onClick={handlePrev}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              {[...Array(totalPages)].map((_, i) => (
                <button
                  key={i}
                  className={`pagination-btn ${
                    currentPage === i + 1 ? "active" : ""
                  }`}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </button>
              ))}
              <button
                className="pagination-btn-next"
                onClick={handleNext}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )} */}
        </div>

        
      </div>
    </div>
  );
};

export default IrnValidationModal;

